import CurrencyLogo from './currency-logo';

export default CurrencyLogo;
